<template>
  <section class="idle">
    <section class="idle_copy">
      <h1>{{txt.idle.title}}</h1>
      <p v-html="txt.idle.copy" />
      <ul v-if="txt" class="idle_navigation" data-tracking-id="fuel savings calculator">
        <li v-if="txt.range_calculator">
          <router-link :to="`/${lang}/${country}/autonomy`" data-tracking-label="start" >
            <template v-if="country === 'uk'">
              <svg class="icon-borne-uk">
                <use xlink:href="#icon-borne-uk" />
              </svg>
            </template>
            <template v-else-if="country === 'norge'">
              <svg class="icon-borne-no">
                <use xlink:href="#icon-borne-no" />
              </svg>
            </template>
            <template v-else>
              <svg class="icon-borne">
                <use xlink:href="#icon-borne" />
              </svg>
            </template>
            {{txt.range_calculator}}
          </router-link>
        </li>
      </ul>
    </section>
    <section class="idle_img">
      <div>
        <img src="@/assets/img/car/empty.webp" alt="empty nissan leaf" />
      </div>
    </section>
  </section>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      txt: state => state.txt.common,
      lang: state => state.lang,
      country: state => state.country
    })
  }
};
</script>